<div class="flex">
  <div class="m-auto kick-motto">
    <div *ngIf="isLoading" class="loading-spinner-correct">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
</div>
